import scatterLinearTrendLine from './scatter-linear-trendline';
import scatterMovingAverageTrendline from './scatter-moving-average';
import { TRENDLINE_LINEAR, TRENDLINE_MOVING_AVERAGE } from '../constants';

const scatterRegistry = {};
scatterRegistry[TRENDLINE_LINEAR] = scatterLinearTrendLine;
scatterRegistry[TRENDLINE_MOVING_AVERAGE] = scatterMovingAverageTrendline;

export default scatterRegistry;
